import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, Navigate, useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { useAuth } from '../services/AuthContext';
import { fetchOptionalAuth } from '../services/AuthService';
import LoginModal from './LoginModal';
import SignupModal from './SignupModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import ResetPasswordComp from './ResetPasswordComp';
import ResetPasswordModal from './ResetPasswordModal';
import ProtectedRoute from './ProtectedRoute';
import AdminStats from './AdminStats'
import AdminUsers from './AdminUsers'
import Dashboard from './Dashboard';
import Profile from './Profile';
import History from './History';
import Statistics from './Statistics';
import Note from './Note';
import Besoin from './Besoin';
import EmailVerification from './EmailVerification';
import Home from './Home';
import BodyScan from './BodyScan';
import Result from './Result';
import CguModal from './CguModal';
import CookieConsent from './CookieConsent';
import { useTranslation } from 'react-i18next';
import { BarChart, List, People, LockFill } from 'react-bootstrap-icons';

import '../css/Sidebar.css';

const COLORS = ['#6F3F89', '#375A9C', '#029FB2', '#29A648', '#E0B614', '#DA5E20', '#C11D24'];

const AppWrapper = () => {
  const {
    isUserAuthenticated,
    authLoading,
    activeModal, 
    setActiveModal,
    userRole,
    hasActiveSubscription,
    handleLogout,
    handleProfile,
    userIsCluf,
    setUserIsCluf,
    token
  } = useAuth();

  const navigate = useNavigate();

  const [hasLoggedVisit, setHasLoggedVisit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [disableHover, setDisableHover] = useState(false); // Etat pour gérer l'activation/désactivation du hover
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (
      hasLoggedVisit ||
      window.location.pathname !== "/" ||
      isUserAuthenticated === undefined
    ) return;

    fetchOptionalAuth("/api/public/visit", {
      method: "POST",
      body: JSON.stringify({ isUserAuthenticated }),
    }).catch((err) => console.error("Erreur log visite page d’accueil :", err));

    setHasLoggedVisit(true);

  }, [isUserAuthenticated, hasLoggedVisit]);
  
  useEffect(() => {
    if (!isUserAuthenticated) {
      // Récupérer la langue du navigateur
      const browserLang = navigator.language || navigator.userLanguage;
      const langCode = browserLang.split('-')[0]; 
      i18n.changeLanguage(langCode); // changer la langue dans i18n
      //console.log("Langue détectée :", langCode);
    }
  }, [isUserAuthenticated, i18n]);

  const handleClick = () => {
    setShowModal(true);
    setDisableHover(true); // Désactiver le hover lors du clic
  };

  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const closeSidebar = () => {
    if (isSidebarVisible) toggleSidebar();
  };

  const handleAcceptCluf = async () => {
    try {
      const response = await fetch('/api/auth/accept-cluf', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        setUserIsCluf(true);
      } else {
        console.error("Erreur lors de l'acceptation du CLUF");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRefuseCluf = () => {
    handleLogout();
  };

  return (
    <>
      <div ver="0.3.3" />

      <div className='app-container'>

      <nav className="navbar">
        {isUserAuthenticated && (
          <div className="logo-logged" onClick={toggleSidebar} style={{ cursor: 'pointer' }}>
            <List size={36} />
          </div>
        )}

        <span 
          className={`eudelix-text ${disableHover ? 'no-hover' : ''}`}
          onClick={handleClick}      
          style={{fontSize: '30px', fontWeight: '500', lineHeight: '1.2'}}
        >     

           {t('topbar.title').split('').map((char, i) => (
            <span
              key={i}
              style={{
                color: 'white', // texte en blanc
                borderBottom: `4px solid ${COLORS[(COLORS.length - i - 1) % COLORS.length]}`, // soulignement coloré
                marginRight: '2px', // petit espace entre lettres
                display: 'inline-block'
              }}
            >
              {char}
            </span>
          ))}
        </span>

        <div className="nav-links">
          {!isUserAuthenticated && (
            <button onClick={() => setActiveModal("login")}>{t('topbar.login')}</button>
          )}
          <div className="admin-icons">
          {userRole === "admin" && (
           <span 
            className="admin-icon"
            onClick={() => navigate('/admin/stats')}
            title="Statistiques globales"
          >
            <BarChart size={30} />
          </span>
          )}
          {userRole === "admin" && (
           <span 
            className="admin-icon"
            onClick={() => navigate('/admin/users')}
            title="Gestion des utilisateurs"
          >
            <People size={30} />
          </span>          
          )}
          </div>
        </div>
      </nav>

      <div className={`sidebar ${isSidebarVisible ? 'show' : ''}`}>
        <ul>
          <li>
            <Link to="/bodyscan" className="sidebar-item" onClick={closeSidebar}>
              <div className="sidebar-item-content">
                <img src="/Images/wheel.png" alt="Scan" className="sidebar-item-img" />
                <p className="sidebar-item-text">{t('leftbar.quiz')}</p>
              </div>
            </Link>
          </li>
          <li>
            <Link to="/note" className="sidebar-item" onClick={closeSidebar}>
              <div className="sidebar-item-content">
                <img src="/Images/note.png" alt="Notes" className="sidebar-item-img" />
                <p className="sidebar-item-text">
                  {t('leftbar.notes')}
                  {!hasActiveSubscription && <LockFill size={12} style={{ marginLeft: 6, verticalAlign: 'middle' }} />}
                </p>
              </div>
            </Link>
          </li>
          <li>
            <Link to="/need" className="sidebar-item" onClick={closeSidebar}>
              <div className="sidebar-item-content">
                <img src="/Images/sandclock.png" alt="Needs" className="sidebar-item-img" />
                <p className="sidebar-item-text">
                  {t('leftbar.needs')}
                  {!hasActiveSubscription && <LockFill size={12} style={{ marginLeft: 6, verticalAlign: 'middle' }} />}
                </p>
              </div>
            </Link>
          </li>
          <li>
            <Link to="/statistics" className="sidebar-item" onClick={closeSidebar}>
              <div className="sidebar-item-content">
                <img src="/Images/stats.png" alt="Stats" className="sidebar-item-img" />
                <p className="sidebar-item-text">{t('leftbar.stats')}</p>
              </div>
            </Link>
          </li>
          <li>
            <Link to="/history" className="sidebar-item" onClick={closeSidebar}>
              <div className="sidebar-item-content">
                <img src="/Images/history.png" alt="History" className="sidebar-item-img" />
                <p className="sidebar-item-text">{t('leftbar.history')}</p>
              </div>
            </Link>
          </li>

          <li>
            <Link to="/profile" className="sidebar-item" onClick={() => { handleProfile(); closeSidebar(); }}>
              <div className="sidebar-item-content">
                <img src="/Images/profile.png" alt="Profile" className="sidebar-item-img" />
                <p className="sidebar-item-text">{t('leftbar.profile')}</p>
              </div>
            </Link>
          </li>
        </ul>
      </div>
      {isSidebarVisible && <div className="sidebar-overlay" onClick={closeSidebar}></div>}


      <div className="main-content">
        <Routes>
          <Route path="/auth/verify/:token" element={<EmailVerification />} />
          <Route path="/auth/resetpassword/:token" element={<ResetPasswordComp />} />
          <Route path="/profile" element={<ProtectedRoute element={<Profile />} />} />
          <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
          <Route path="/history" element={<ProtectedRoute element={<History />} />} />
          <Route path="/statistics" element={<ProtectedRoute element={<Statistics />} />} />
          <Route path="/note" element={<ProtectedRoute element={<Note />} requireSubscription />} />
          <Route path="/need" element={<ProtectedRoute element={<Besoin />} requireSubscription />} />
          <Route path="/bodyscan" element={<BodyScan />} />
          <Route path="/result" element={<Result />} />
          <Route path="/admin/stats" element={<ProtectedRoute element={<AdminStats />} />} />
          <Route path="/admin/users" element={<ProtectedRoute element={<AdminUsers />} />} />
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>

      {/* Modal explicatif */}
      
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header>
          <Modal.Title>{t('eudelix.story.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-custom">
            {t('eudelix.story.message1')}
            </p>
          <p className="text-custom">
            {t('eudelix.story.message2')}
            </p>
          <p className="text-custom">
            {t('eudelix.story.message3')}
            </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t('eudelix.story.close')}
          </Button>
        </Modal.Footer>
      </Modal>      

      {/* Modale de connexion */}
      <LoginModal
        show={activeModal === "login"}
        handleClose={() => setActiveModal(null)}
        onRequestForgot={() => setActiveModal("forgot")}
        onRequestSignup={() => setActiveModal("signup")}
      />

      <SignupModal
        show={activeModal === "signup"}
        handleClose={() => setActiveModal(null)}
      />

      <ForgotPasswordModal
        show={activeModal === "forgot"}
        handleClose={() => setActiveModal(null)}
      />

      <ResetPasswordModal            
        show={activeModal === "reset"}
        handleClose={() => setActiveModal(null)}
      />

      {/* CGU Modal */}
      {!authLoading && isUserAuthenticated && userIsCluf === false && (
        <CguModal
          show={true}
          onAccept={handleAcceptCluf}
          onRefuse={handleRefuseCluf}
        />
      )}

      {/* Cookie Consent Banner */}
      <CookieConsent />
    </div>
    </>
  );
};

export default AppWrapper;
